import "../CoinWallet/index.css";
import "./index.css";
import withDashboard from "../../HOC/withDashboard";
import BtcImg from "../../assets/bitcoin.png";
import EthImg from "../../assets/ethereum.png";
import UsdtImg from "../../assets/usdt.png";
import { Button } from "@mui/material";
import Chart from "../../components/Chart";
import CardLayout from "../../components/CardLayout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PriceCardList from "../../components/PriceCardList";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { formatNumberWithCommas } from "../../utils";

const ViewTransactionDetail = () => {
  const navigate = useNavigate();
  const Btc = useSelector(({ Btc }) => Btc);
  const Eth = useSelector(({ Eth }) => Eth);
  const Usdt = useSelector(({ Usdt }) => Usdt);
  const User = useSelector(({ User }) => User);
  const { selectedCoin, currentUser, testConfig, prodConfig, enviroment } =
    User;
  const { currencySymbol, currency } = currentUser || {};
  const config = enviroment === "test" ? testConfig : prodConfig;
  const { BTC_EXPLORER, ETH_EXPLORER, USDT_EXPLORER } = config;

  const coinMappings = {
    BTC: {
      coinName: "Bitcoin",
      circleColor: "yellow-circle",
      baseColor: "yellow",
      borderColor: "rgba(244, 183, 63, 1)",
      backgroundColor: "rgba(244, 183, 63, 0.2)",
      selectedReducer: Btc,
      image: BtcImg,
      explorer: BTC_EXPLORER,
    },
    ETH: {
      coinName: "Ethereum",
      circleColor: "blue-circle",
      baseColor: "blue",
      borderColor: "rgba(0, 107, 250, 1)",
      backgroundColor: "rgba(0, 107, 250, 0.2)",
      selectedReducer: Eth,
      image: EthImg,
      explorer: ETH_EXPLORER,
    },
    USDT: {
      coinName: "Tether",
      circleColor: "green-circle",
      baseColor: "green",
      borderColor: "rgba(75, 192, 192, 1)",
      backgroundColor: "rgba(75, 192, 192, 0.2)",
      selectedReducer: Usdt,
      image: UsdtImg,
      explorer: USDT_EXPLORER,
    },
  };
  const selectedCoinData = coinMappings[selectedCoin];

  const {
    coinName,
    baseColor,
    borderColor,
    backgroundColor,
    selectedReducer,
    image,
    explorer,
  } = selectedCoinData;

  const { prices, balance, labels, priceNow, selectedTransaction } =
    selectedReducer;
  const { sender, receiver, transactionHx, amount, fee, date } =
    selectedTransaction;

  const transactionFeeCoin = selectedCoin === "USDT" ? "ETH" : selectedCoin;
  // Format Date
  const transactionDate = new Date(date);
  const totalAmount =
    selectedCoin === "USDT" ? amount : parseFloat(amount) + parseFloat(fee);
  const formattedDate = `${transactionDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  })} on ${transactionDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  })}`;

  const ViewOnBlockchain = () => {
    const url = `${explorer}${transactionHx}`;
    window.open(url, "_blank");
  };
  let formattedBalance = parseFloat(balance).toFixed(7);
  if (isNaN(formattedBalance)) {
    formattedBalance = "0"; // Fallback if balance is not a valid number
  } else if (Number.isInteger(parseFloat(formattedBalance))) {
    formattedBalance = parseFloat(formattedBalance).toString();
  }
  return (
    <div className="wallets-container">
      <PriceCardList />
      <CardLayout>
        <div className="coinwallet-back-btn">
          <Button variant="outlined" onClick={() => navigate(-1)}>
            <ArrowBackIcon /> Back
          </Button>
        </div>
        <div className="coinwallet-container">
          <div className="coinwallet-info-container">
            <div className="coinwallet-info review-info">
              <img src={image} className="coinwallet-img" alt="card.png" />
              <div className="coinwallet-info-text-container">
                <div className="coinwallet-info-price">
                  <span> Price: </span> {currencySymbol}
                  {formatNumberWithCommas(priceNow)} {currency}
                </div>
                <div className="coinwallet-info-balance">
                  <span> Balance: </span>
                  {formattedBalance} {selectedCoin}
                </div>
              </div>
            </div>
            <div className="coinwallet-chart-title">
              Price of {coinName} in previous 7 days
            </div>
            <div className="coinwallet-chart">
              <Chart
                borderColor={borderColor}
                backgroundColor={backgroundColor}
                prices={prices}
                labels={labels}
              />
            </div>
          </div>
          <div className="review-transaction-details">
            <div className="review-transaction-item">
              <div className="review-transaction-title">Date:</div>
              <div className="review-transaction-value">{formattedDate}</div>
            </div>
            <div className="review-transaction-item">
              <div className="review-transaction-title">Amount:</div>
              <div className="review-transaction-value">
                {amount} {selectedCoin}
              </div>
            </div>
            <div className="review-transaction-item">
              <div className="review-transaction-title">Transaction Fee:</div>
              <div className="review-transaction-value">
                {fee.toString()} {transactionFeeCoin}
              </div>
            </div>
            <div className="review-transaction-item">
              <div className="review-transaction-title">Total Amount:</div>
              <div className="review-transaction-value">
                {totalAmount} {selectedCoin}
              </div>
            </div>
            <div className="review-transaction-item">
              <div className="review-transaction-title">From:</div>
              <div className="review-transaction-value">
                {selectedCoin} Wallet
              </div>
            </div>
            <div className="review-transaction-item">
              <div className="review-transaction-title">From:</div>
              <div className="review-transaction-value">{sender}</div>
            </div>
            <div className="review-transaction-item">
              <div className="review-transaction-title">To:</div>
              <div className="review-transaction-value">{receiver}</div>
            </div>
            <div className="review-transaction-item border-bottom-none">
              <div className="review-transaction-title">Transaction Hash:</div>
              <div className="review-transaction-value">{transactionHx}</div>
            </div>
            <div className="review-btn-container">
              <Button
                variant="contained"
                className={`continue ${baseColor}`}
                onClick={ViewOnBlockchain}
              >
                View on Explorer
              </Button>
            </div>
          </div>
        </div>
      </CardLayout>
    </div>
  );
};

export default withDashboard(ViewTransactionDetail);
